import { useTranslation } from 'libs/i18n';
import { Input, Stack, Typography } from 'libs/ui';
import { SettingsContent } from 'modules/administration/common/components';

import { Field, useFormContext } from '../../../forms/accountingSystemForm';

export const PasswordSettings = () => {
  const { t } = useTranslation();
  const { readOnly, values } = useFormContext();

  const editable = !readOnly;

  return (
    <SettingsContent
      leftContent={
        <Stack justifyContent="space-between" spacing={8}>
          <Typography variant="bodyBold">
            {t('administration.accountingSystem.password.title')}
          </Typography>
          {editable && (
            <Stack alignItems="center" direction="row" spacing={16}>
              <Typography variant="bodyMedium">
                {t('administration.accountingSystem.password.switchLabel')}
              </Typography>
              <Field.Switch name="isPasswordLimited" />
            </Stack>
          )}
        </Stack>
      }
      rightContent={
        !values.isPasswordLimited ? (
          <Input
            disabled
            readOnly
            label={t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.label'
            )}
            value={t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.unlimited'
            )}
          />
        ) : (
          <Field.Number
            helperTextAbsolute
            showRequiredMark
            format={(v) => (!v ? '' : Number(v))}
            label={t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.label'
            )}
            name="passwordExpiresInDays"
            placeholder={t(
              'administration.accountingSystem.password.passwordExpiresInDaysField.placeholder'
            )}
          />
        )
      }
    />
  );
};
